import { Dispatch, SetStateAction } from 'react'
import { Button, Dialog, DialogContent, Grid, Typography, useTheme } from '@mui/material'

import meshifyCentralLogo from '../../../images/meshify-central-logo.svg'
import { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK } from '../../../utils/constants'
import useSharedStyles from '../../../utils/shared.styles'

import useStyles from './index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const AboutModal = (props: IProps) => {
  const theme = useTheme()
  const { open, setOpen } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const currentYear = new Date().getFullYear()

  const version = APP_VERSION

  return (
    <Dialog
      onClose={() => setOpen(false)}
      open={open}
      slotProps={{
        paper: {
          sx: { width: '310px' },
        },
      }}
    >
      <DialogContent>
        <Grid container={true} spacing={0} sx={sharedClasses.centerContentHorizontal}>
          <Grid sx={classes.centerAlign} size={12}>
            <img src={meshifyCentralLogo} alt="logo" style={classes.logo(theme)} />
          </Grid>

          <Grid sx={classes.centerAlign} size={12}>
            <Typography variant="body1" sx={sharedClasses.secondaryText}>
              Version # {version}
            </Typography>
          </Grid>

          <Grid sx={classes.centerAlign} size={12}>
            <Typography component="a" variant="body1" href="/release-notes" rel="noreferrer">
              Release Notes
            </Typography>
          </Grid>

          <Grid sx={classes.centerAlign} size={12}>
            <Typography component="a" variant="body1" href={PRIVACY_POLICY_LINK} target="blank" rel="noreferrer">
              Privacy Policy
            </Typography>

            <Typography variant="caption" sx={sharedClasses.secondaryText}>
              &nbsp;•&nbsp;
            </Typography>

            <Typography component="a" variant="body1" href={TERMS_OF_USE_LINK} target="blank" rel="noreferrer">
              Terms of Use
            </Typography>
          </Grid>

          <Grid sx={classes.centerAlign} size={12}>
            <Typography variant="body1" sx={sharedClasses.secondaryText}>
              ©{currentYear} Meshify, Inc.
            </Typography>
          </Grid>

          <Grid size={10}>
            <Button onClick={() => setOpen(false)} fullWidth={true} variant="outlined" sx={classes.okBtn}>
              OK
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default AboutModal
